import { render } from "./ProductNotGranted.vue?vue&type=template&id=0bea560b&scoped=true"
import script from "./ProductNotGranted.vue?vue&type=script&lang=js"
export * from "./ProductNotGranted.vue?vue&type=script&lang=js"

import "./ProductNotGranted.vue?vue&type=style&index=0&id=0bea560b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bea560b"]])

export default __exports__